<template>
  <transition
    enter-active-class="card__dropdown--enter"
    leave-active-class="card__dropdown--leave"
  >
    <div class="card" id="facturasVenta" v-if="displayAnimation">
      <div class="card__title mb-3">
        <h5>{{ title }}</h5>
        <div class="card__controls">
          <label>
            <input :name="nameOption" v-model="option" type="radio" value="C" />
            <span>Cantidades</span>
          </label>
          <label>
            <input :name="nameOption" v-model="option" type="radio" value="M" />
            <span>Montos</span>
          </label>
        </div>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="graph-box">
              <div class="graph-box__content">
                <column-chart 
                  :data="(option==='M') ? dataChartMontoElect : dataChartCantElect"
                ></column-chart>
              </div>
              <div class="graph-box__info">
                <span class="graph-box__title">
                  <i class="fa fa-file-text"></i>Electrónicas
                </span>
                <span
                  class="graph-box__values"
                >{{`Total: ${((option==='M')?'$' + totalMontoElect: '' + totalCantElect)}`}}</span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="graph-box">
              <div class="graph-box__content">
                <column-chart
                  :data="(option==='M') ? dataChartMontoManual : dataChartCantManual"
                ></column-chart>
              </div>
              <div class="graph-box__info">
                <span class="graph-box__title">
                  <i class="fa fa-pencil"></i>Manuales
                </span>
                <span
                  class="graph-box__values"
                >{{`Total: ${((option==='M')?'$' + totalMontoManual: '' + totalCantManual)}`}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    nameOption: {
      required: true
    },
    displayAnimation: {
      type: Boolean,
      required: true
    },
    totalMontoElect: {
      required: true
    },
    totalCantElect: {
      required: true
    },
    totalMontoManual: {
      required: true
    },
    totalCantManual: {
      required: true
    },
    dataChartMontoManual: {
      type: Array,
      required: false,
      default: []
    },
    dataChartCantManual: {
      type: Array,
      required: false,
      default: []
    },
    dataChartMontoElect: {
      type: Array,
      required: false,
      default: []
    },
    dataChartCantElect: {
      type: Array,
      required: false,
      default: []
    },
  },
  data: function() {
    return {
      option: 'M'
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/TransitionCharts.vue